import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import moment from "moment";
import "moment-timezone";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { BACKEND } from "../config/configEnvs";
import { FaClock } from "react-icons/fa";
import { Button } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BarChartIcon from "@mui/icons-material/BarChart"; // Icono de estadísticas
import PaginationItem from "../components/ui/components/Pagination";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import { toast } from "react-toastify";


function RegistrosAsistencia() {

  const [registros, setRegistros] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0)
  const [totalPages, setTotalPages] = useState(0)

  const [limit, setLimit] = useState(30)
  const [page, setPage] = useState(1)

  const [filtroMotivo, setFiltroMotivo] = useState("");

  const [loadingStatus, setLoadingStatus] = useState(false)

  const [graceTime, setGraceTime] = useState(5)

  const diasMapeados = { // No se manejan tíldes en la BD, convertimos automáticamente los datos
    "lunes": "lunes",
    "martes": "martes",
    "miércoles": "miercoles",
    "jueves": "jueves",
    "viernes": "viernes",
    "sábado": "sabado",
    "domingo": "domingo"
  };

  const formatDate = (dateString) => {
    const formattedDate = moment(dateString)
      .tz("America/Lima") // Ajusta al horario de Perú
      .format("YYYY-MM-DD HH:mm:ss"); // Formato deseado
    return formattedDate;
  };

  const user = useSelector((state) => state.auth.user);

  const getRecord = async () => {
    try {
      setLoadingStatus(true)
      let url = `${BACKEND}/api/asistencias?limit=${limit}&page=${page}&where[usuario][equals]=${user.id}`
      
      if (filtroMotivo) {
        url += `&where[motivo][equals]=${filtroMotivo}`
      }

      const response = await axios.get(url)

      setRegistros(response.data.docs)
      setTotalDocs(response.data.totalDocs)
      setTotalPages(response.data.totalPages)

    } catch (e) {
      toast.error("Error al cargar los registros: " + e)
    } finally {
      setLoadingStatus(false)
    }
  }

  useEffect(() => {
    getRecord()
  }, []);

  useEffect(() => {
    getRecord()
  }, [page, limit, filtroMotivo]);

  function isTardanza(registro) {

    // Se usa esta función ya que no manejamos tíldes en la BD, 
    function obtenerDiaDeLaSemana(fecha) {
      const diaConTilde = moment(fecha).format("dddd").toLowerCase();
      return diasMapeados[diaConTilde] || diaConTilde;
    }
    
    // Hora a la que se marcó el registro en el sistema
    const horaRegistro = moment(registro.fecha).tz("America/Lima"); 
  
    // Día el que se marcó el registro en el sistema
    const diaDeLaSemana = obtenerDiaDeLaSemana(registro.fecha);

    // Miramos el horario del usuario
    const horarioUsuario = registro.usuario?.horarios?.find(horario => horario.dia === diaDeLaSemana);

    if (!horarioUsuario) { // Si no hay horario, el trabajador no trabaja ese día
      return false;
    }
    
    const horaEntradaEstandar = moment(registro.fecha) // Hora de entrada estándar del trabajador
      .tz("America/Lima")
      .set({
        hour: parseInt(horarioUsuario.horaEntrada.split(":")[0]),
        minute: parseInt(horarioUsuario.horaEntrada.split(":")[1]),
        second: 0
      });

    const tiempoLimite = moment(horaEntradaEstandar).add(graceTime, "minutes");// Tiempo límite con tolerancia

    const isTardanza = registro.motivo === "Entrada Trabajo" && horaRegistro.isAfter(tiempoLimite);

    return isTardanza;
  }

  function isHorasExtra(registro) {

    function obtenerDiaDeLaSemana(fecha) {
      const diaConTilde = moment(fecha).format("dddd").toLowerCase();
      return diasMapeados[diaConTilde] || diaConTilde;
    }
  
    const horaRegistro = moment(registro.fecha).tz("America/Lima")

    const diaDeLaSemana = obtenerDiaDeLaSemana(registro.fecha);

    const horarioUsuario = registro.usuario?.horarios?.find(horario => horario.dia === diaDeLaSemana)

    if (!horarioUsuario) {
      return false
    }

    const horaSalidaEstandar = moment(registro.fecha)
    .tz("America/Lima")
    .set({
      hour: parseInt(horarioUsuario.horaSalida.split(":")[0]),
      minute: parseInt(horarioUsuario.horaSalida.split(":")[1]),
      second: 0
    })

    const tiempoExtra = moment(horaSalidaEstandar).add(10, "minutes");// Tiempo límite con tolerancia

    const isHorasExtra = registro.motivo === "Salida Trabajo" && horaRegistro.isAfter(tiempoExtra)


    return isHorasExtra
  }

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  function getMotivoColor(motivo) {
    switch (motivo) {
      case "Entrada Trabajo":
        return "bg-green-500";
      case "Salida Trabajo":
        return "bg-red-500";
      case "Salida Almuerzo":
        return "bg-purple-500";
      case "Entrada Almuerzo":
        return "bg-blue-500";
      default:
        return "";
    }
  }

  return (
    <div className="flex flex-col h-screen w-full">

      {/* Navbar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto">

          <div className="flex items-center gap-4 p-4">
            <FaClock className="text-2xl text-gray-700" />
            <h2 className="text-2xl font-bold text-gray-700"> Historial de Registros de Asistencia </h2>
          </div>
  

          <div className="flex flex-row gap-4 items-center justify-center">

            <div>
              <Link to="/home/marcar-asistencia">
                <Button
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    fontFamily: "poppins",
                    padding: "4px 24px",
                    backgroundColor: "#ff6400",
                    transform: "all",
                    animationDuration: "1000",
                    textTransform: "none",
                    borderRadius: "8px",
                    '&:hover': {
                      backgroundColor: "#bb4a03",
                    }
                  }}
                >
                  Volver
                </Button>
              </Link>
            </div>

            <div>
              <Link to="/home/estadisticas">
                <Button
                  variant="contained"
                  startIcon={<BarChartIcon />}
                  sx={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    fontFamily: "poppins",
                    padding: "4px 24px",
                    backgroundColor: "#ff6400",
                    transform: "all",
                    animationDuration: "1000",
                    textTransform: "none",
                    borderRadius: "8px",
                    '&:hover': {
                      backgroundColor: "#bb4a03",
                    }
                  }}
                >
                  Mis Estadísticas
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Barra de filtros*/}
      <div className="flex flex-row items-center justify-center bg-gray-100 mt-2 mb-1 gap-8">

        <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
          <span className="truncate">Motivo:</span>
          <select
            value={filtroMotivo}
            onChange={(e) => setFiltroMotivo(e.target.value)}
            className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
          >
            <option value="">Todos</option>
            <option value="Entrada Trabajo">Entrada Trabajo</option>
            <option value="Salida Almuerzo">Salida Almuerzo</option>
            <option value="Entrada Almuerzo">Entrada Almuerzo</option>
            <option value="Salida Trabajo">Salida Trabajo</option>
          </select>
        </div>

        <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-2">
          <span className="truncate">Límite:</span>
          <select
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-0 focus:border-gray-300 py-[6px] pr-10"
          >
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loadingStatus ? (
          <LoadingScreen />
        ) : (
          registros.length === 0 ? (
            <NoDataScreen />
          ) : (
            <table className="w-full table-fixed">

              <thead className="bg-white sticky top-0 z-50">
                <tr className="w-full text-gray-700 text-center text-sm uppercase font-semibold">
                  <td className="w-[33%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Nombre
                  </td>
                  <td className="w-[33%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Motivo
                  </td>
                  <td className="w-[33%] px-6 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                    Fecha y hora
                  </td>
                </tr>
              </thead>
    
              <tbody>
                {registros.map((registro, index) => {
                  return (
                    <tr
                      key={registro.id}
                      className="text-xs w-full hover:bg-gray-100 transition-all duration-100"
                    >
                      <td className="border border-gray-300 p-2">
                        {registro.usuario?.name}
                      </td>
                      <td className="border border-gray-300 p-2">
                        <span
                          className={`inline-block h-4 w-4 rounded-full mr-2 ${getMotivoColor(
                            registro.motivo
                          )}`}
                        ></span>
                        {registro.motivo}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {formatDate(registro.fecha)}
                        {isTardanza(registro) && (
                          <span className="inline-block bg-red-500 text-white rounded px-2 ml-2">
                            Tardanza
                          </span>
                        )}
                        {isHorasExtra(registro) && (
                          <span className="inline-block bg-blue-500 text-white rounded px-2 ml-2">
                            Horas Extra
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )
        )}
      </div>
      
      {/* Paginador */}
      <PaginationItem
        actualDocs={registros.length}
        totalDocs={totalDocs}
        entity={"Registros"}
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}

export default RegistrosAsistencia;
